import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]

import StrategyBriefResource from '@/brief-hub/brief/StrategyBriefResource';
    import {computed, ref, watch} from 'vue';
    import FunctionalScope, {FunctionalScopeItem} from '@/brief-hub/brief/FunctionalScope';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {useBriefStrategyStore} from '@/brief-hub/stores/briefStrategy.store';
    import StrategyBriefHubStepLayout from '@/brief-hub/common/ui/layout/StrategyBriefHubStepLayout.vue';
    import {StrategyFreelancerFunctionalScopesBriefRequest} from '@/common/api/api-raw-types';
    import {useBriefAmplitudeEvent} from '@/common/composable/useBriefAmplitudeEvent';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyBriefFreelancerFunctionalScopes',
  setup(__props) {

    const {$msg, $features} = useGlobalProperties();
    const briefStrategyStore = useBriefStrategyStore();
    const brief = computed<StrategyBriefResource | null>(() => briefStrategyStore.brief);
    const {triggerBriefFunnelStepEnteredAmplitudeEvent} = useBriefAmplitudeEvent();

    const functionalScopes = ref<FunctionalScope[]>([]);
    const globalScopes = computed<FunctionalScopeItem[] | null>(() =>
        functionalScopes?.value ? functionalScopes?.value?.map((functionalScope) => functionalScope.globalScope) : null,
    );
    const specificScopes = ref<FunctionalScopeItem[] | null>(null);
    const selectedGlobalScopeHumanId = ref<string>('');
    const selectedSpecificScopeHumanId = ref<string>('');

    async function init() {
        const [data, error] = await brief.value!.getFunctionalScopesByCategory();
        if (error || !data) {
            pushVJoySnackbar({
                props: {
                    message: $msg('customer.brief.error.unknown'),
                    level: 'error',
                },
            });
        } else {
            functionalScopes.value = data;
            selectedGlobalScopeHumanId.value = briefStrategyStore.briefStrategyFunctionalScopes.globalScopeHumanId || '';
            selectedSpecificScopeHumanId.value = briefStrategyStore.briefStrategyFunctionalScopes.specificScopeHumanId || '';
        }
        triggerBriefFunnelStepEnteredAmplitudeEvent('functional-scope', 2);
    }

    init();

    watch(selectedGlobalScopeHumanId, () => {
        specificScopes.value =
            functionalScopes.value?.find((globalScope) => globalScope?.globalScope?.humanId === selectedGlobalScopeHumanId.value)?.specificScopes ||
            null;
    });

    watch(selectedSpecificScopeHumanId, () => {
        if (selectedSpecificScopeHumanId.value && selectedGlobalScopeHumanId.value) {
            const payload: StrategyFreelancerFunctionalScopesBriefRequest = {
                functionalScopes: [
                    {
                        globalScopeHumanId: selectedGlobalScopeHumanId.value,
                        specificScopeHumanId: selectedSpecificScopeHumanId.value,
                    },
                ],
            };
            briefStrategyStore.updatePayload({
                type: 'StrategyFreelancerFunctionalScopesBriefRequest',
                payload: payload,
            });
        } else {
            briefStrategyStore.resetPayload();
        }
    });

return (_ctx: any,_cache: any) => {
  const _component_VJoySelect = _resolveComponent("VJoySelect")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(StrategyBriefHubStepLayout, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.functional.scope.title')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_VJoyWrapper, {
          direction: "column",
          align: "stretch",
          "no-margin": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_openBlock(), _createBlock(_component_VJoySelect, {
                id: "global-scope",
                key: selectedGlobalScopeHumanId.value,
                modelValue: selectedGlobalScopeHumanId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedGlobalScopeHumanId).value = $event)),
                "data-testid": "brief-strategy-global-scope",
                label: _unref($msg)('customer.brief.exec.form.functional.scope.global.label')
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("option", {
                    disabled: "",
                    value: "",
                    selected: ""
                  }, "-", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(globalScopes.value, (globalScope) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: globalScope.humanId,
                      value: globalScope.humanId
                    }, _toDisplayString(globalScope.translation), 9, _hoisted_1))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_VJoySelect, {
                id: "specific-scope",
                modelValue: selectedSpecificScopeHumanId.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSpecificScopeHumanId).value = $event)),
                "data-testid": "brief-strategy-specific-scope",
                label: _unref($msg)('customer.brief.exec.form.functional.scope.specific.label')
              }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("option", {
                    disabled: "",
                    value: "",
                    selected: ""
                  }, "-", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specificScopes.value, (specific) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: specific.humanId,
                      value: specific.humanId
                    }, _toDisplayString(specific.translation), 9, _hoisted_2))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "label"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})